<script lang="ts">
  import { onMount } from "svelte";
  import Typography from "./Typography.svelte";
  import { TypographyType } from "../lib/constants/typographyMap";

  export let onCountdownComplete: () => void;
  export let nextRetryAt: string = new Date(new Date().setSeconds(new Date().getSeconds() + 60)).toISOString();

  let timeLeft = Math.ceil((new Date(nextRetryAt).getTime() - Date.now()) / 1000);
  let timer: ReturnType<typeof setInterval>;
  let displayTime = "";

  onMount(() => {
    timer = setInterval(() => {
      timeLeft = Math.ceil((new Date(nextRetryAt).getTime() - Date.now()) / 1000);
      displayTime = timeLeft.toString();
      if (timeLeft <= 0) {
        clearInterval(timer);
        onCountdownComplete();
      }
    }, 1000);

    displayTime = timeLeft.toString();

    // https://svelte.dev/docs/svelte/lifecycle-hooks#onMount
    return () => {
      clearInterval(timer);
    };
  });
</script>

<div>
  {#if timeLeft > 0}
    <div class="heading text-center lg:text-left mt-2 lg:mt-0">
      <Typography
        mobile={TypographyType.Body1Medium}
        desktop={TypographyType.Headline2}
        --font-color=var(--subheader-font-color)>
        <h2>Please wait {displayTime} seconds to try again.</h2>
      </Typography>
    </div>
  {/if}
</div>
